import React, { useState } from 'react';
import { Check, AlertCircleIcon } from 'lucide-react';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsError(false);
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(Object.fromEntries(formData))
      });
      const data = await response.json().catch(() => null);
      if (response.ok && data && data.success) {
        setIsSuccess(true);
        form.reset();
        setTimeout(() => setIsSuccess(false), 5000);
      } else {
        console.error('Web3Forms error:', data);
        setIsError(true);
      }
    } catch (err) {
      console.error('Web3Forms network error:', err);
      setIsError(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section className="w-full bg-black py-20 px-4 border-t border-zinc-900" id="contact-form" data-id="element-106" data-mp="37otayfymes1">
      <div className="max-w-3xl mx-auto" data-id="element-107" data-mp="86rnfnuej0l8">
        <div className="text-center mb-12" data-id="element-108" data-mp="36mu7vwkixp03">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase mb-4" data-id="element-109" data-mp="36o5dm1xj56tu">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-sky-300 via-blue-400 to-blue-600" data-id="element-110" data-mp="3blxg1pvswbca">
              Contact Us
            </span>
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto rounded-full shadow-[0_0_10px_rgba(59,130,246,0.8)]" data-id="element-111" data-mp="3kmc1cp8rlqfs" />
          <p className="text-xl sm:text-2xl md:text-4xl mt-6 font-semibold bg-clip-text text-transparent bg-gradient-to-b from-sky-300 via-blue-400 to-blue-600" data-id="element-112" data-mp="vt7zh1lpgo05">
            Fill out the form and we will send you a custom quote.
          </p>
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-xl" data-id="element-113" data-mp="2rxea58zzix2z">
          {isSuccess ? <div className="flex flex-col items-center justify-center py-12 text-center animate-in fade-in zoom-in duration-500" data-id="element-114" data-mp="35wx7d6r9co0i">
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-115" data-mp="30z5heia6bbyy">
                <Check className="w-8 h-8 text-green-500" data-id="element-116" data-mp="2d9b6455i5vgt" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-117" data-mp="297pknvewk8v0">
                Message Sent!
              </h3>
              <p className="text-gray-500" data-id="element-118" data-mp="2mz2zwx5s2kk8">
                Thank you for reaching out. Mike will get back to you shortly.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-119" data-mp="1ui0gdrbijoqi">
              {/* Hidden Web3Forms config fields */}
              <input type="hidden" name="access_key" value="117a1b08-1717-47b9-b0bd-edf47d626a50" data-id="element-120" data-mp="1pjgs3k9g60uz" />
              <input type="hidden" name="subject" value="New Quote Request - Mike's Pro Detail" data-id="element-121" data-mp="50cxwehymz5c" />
              <input type="hidden" name="from_name" value="Mike's Pro Detail Website" data-id="element-122" data-mp="9s4sr185fr1a" />

              {isError && <div className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700" data-id="element-123" data-mp="3s648tr0tdwk1">
                  <AlertCircleIcon className="w-5 h-5 flex-shrink-0" data-id="element-124" data-mp="10ck8w2oqrzc" />
                  <p className="text-sm font-medium" data-id="element-125" data-mp="op5bif8d4bnm">
                    Something went wrong. Please try again or call (818)
                    381-9905 directly.
                  </p>
                </div>}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-126" data-mp="er7nnsuf0gvj">
                <div className="space-y-2" data-id="element-127" data-mp="et2bpg0zgp3u">
                  <label htmlFor="name" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-128" data-mp="jopzbqztha78">
                    Name *
                  </label>
                  <input type="text" id="name" name="name" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="John Doe" data-id="element-129" data-mp="34fqh61m55zpz" />
                </div>
                <div className="space-y-2" data-id="element-130" data-mp="3awthivn9iruu">
                  <label htmlFor="email" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-131" data-mp="3axl45gyvtf8z">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="john@example.com" data-id="element-132" data-mp="6i3jzc69zsj8" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-133" data-mp="3or41z0s87zv3">
                <div className="space-y-2" data-id="element-134" data-mp="2ia8sw2y68tuz">
                  <label htmlFor="phone" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-135" data-mp="2d9ukgjsnrhwf">
                    Phone *
                  </label>
                  <input type="tel" id="phone" name="phone" required autoComplete="tel" pattern="[\d\s\-\+\(\)\.]{7,}" className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="(555) 123-4567" data-id="element-136" data-mp="233jk2d7tkap2" />
                </div>
                <div className="space-y-2" data-id="element-137" data-mp="2lvcbi378pnuo">
                  <label htmlFor="vehicle" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-138" data-mp="2lyi59vqtddwq">
                    Make / Model *
                  </label>
                  <input type="text" id="vehicle" name="vehicle" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="e.g. 2023 Tesla Model 3" data-id="element-139" data-mp="2vs8nwk09eu4i" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-140" data-mp="ydw72qzb9uyn">
                <label htmlFor="source" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-141" data-mp="yexqpjue7prz">
                  Where did you hear about us?
                </label>
                <input type="text" id="source" name="source" className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors" placeholder="Google, Yelp, Friend, etc." data-id="element-142" data-mp="18ega9z6e59ji" />
              </div>

              <div className="space-y-2" data-id="element-143" data-mp="1ccmeazfuhb0q">
                <label htmlFor="service" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-144" data-mp="1r3mnj6of18xx">
                  Type of Service *
                </label>
                <select id="service" name="service" required className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors appearance-none" style={{
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%239ca3af' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
              backgroundPosition: 'right 0.5rem center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '1.5em 1.5em',
              paddingRight: '2.5rem'
            }} data-id="element-145" data-mp="203rtdcdynz9z">
                  <option value="" disabled selected data-id="element-146" data-mp="20r8sii0bcyal">
                    Select a service...
                  </option>
                  <option value="Basic Wash" data-id="element-147" data-mp="1n159dzwqdkpd">Basic Wash</option>
                  <option value="Wash & Wax" data-id="element-148" data-mp="1r0nuavojxvs7">Wash & Wax</option>
                  <option value="Full Detail" data-id="element-149" data-mp="1qyt7fbtpztlh">Full Detail</option>
                  <option value="Interior Detail" data-id="element-150" data-mp="1d2pju1dcqjhz">Interior Detail</option>
                  <option value="Engine Bay Cleaning" data-id="element-151" data-mp="1i0qyma3qvwnn">
                    Engine Bay Cleaning
                  </option>
                  <option value="Others" data-id="element-152" data-mp="1xh7ikpmpetqy">Others</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-153" data-mp="1skpdtprdivem">
                <label htmlFor="message" className="block text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-154" data-mp="1ohsqjlqw2b4c">
                  Message
                </label>
                <textarea id="message" name="message" rows={4} className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors resize-none" placeholder="Tell us more about what you need..." data-id="element-155" data-mp="1ji7v3laxgkwd"></textarea>
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-gradient-to-r from-blue-500 to-blue-700 text-white font-bold text-lg uppercase tracking-wider rounded-lg hover:from-blue-400 hover:to-blue-600 transition-all shadow-[0_0_20px_rgba(59,130,246,0.3)] hover:shadow-[0_0_30px_rgba(59,130,246,0.5)] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-156" data-mp="10sroqhck9y81">
                {isSubmitting ? <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-157" data-mp="37ilaxtj7vh2i">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-158" data-mp="3ghggd3efsn4r"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-159" data-mp="2js7d1mdyao00"></path>
                    </svg>
                    Sending...
                  </> : 'Send Message'}
              </button>
            </form>}
        </div>
      </div>
    </section>;
}